import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'
import * as Yup from 'yup'

import { initiatePerksBenefitRenewal } from 'core'

import { Alert, Button, DefaultDatePickerV2, Modal, Row } from 'common/components'
import { nowV2 } from 'common/dateFormatters'
import { useCommandRequestV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

const schema = Yup.object({
  startDate: Yup.string().required(),
})

const RenewalBanner = () => {
  const history = useHistory()

  const { sendCommand: initiateRenewalCommand, isLoading: loading } = useCommandRequestV2<void, string>((args) =>
    initiatePerksBenefitRenewal(args),
  )

  const [showRenewalConfirmModal, setShowRenewalConfirmModal] = useState(false)
  const [formIsValid, setFormIsValid] = useState(false)

  const formRef = useRef<HTMLFormElement | null>(null)

  return (
    <div data-testid={'perks-renewal-banner'}>
      <Alert
        className="mb-16"
        banner
        showIcon
        type="info"
        message="Ready to design your benefits? Renew your benefits now."
        action={<Button onClick={() => setShowRenewalConfirmModal(true)}>Start benefit renewal</Button>}
      />
      <Modal
        visible={showRenewalConfirmModal}
        title="Benefit Renewal Notice"
        okText="Confirm"
        okButtonProps={{ disabled: !formIsValid, loading }}
        onCancel={() => setShowRenewalConfirmModal(false)}
        onOk={() => formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}
      >
        <Row className="mb-16">
          <p>You can reconfigure your WorkPerks benefit design.</p>
          <p>
            If you select and save a start date, then your WorkPerks benefit will auto-renew with its current settings.
            We will notify your employees about their new benefit design.
          </p>
        </Row>
        <Row>
          <Formik
            initialValues={{ startDate: null }}
            validationSchema={schema}
            validate={(values) => setFormIsValid(schema.isValidSync(values))}
            onSubmit={async ({ startDate }) => {
              const result = await initiateRenewalCommand(startDate)
              if (result.completed) {
                history.push(`${ROUTE_PATHS.RENEWAL_TASKS}`)
              }
            }}
          >
            {({ handleSubmit }) => (
              <form ref={formRef} onSubmit={handleSubmit}>
                <DefaultDatePickerV2
                  name="startDate"
                  label="Benefit Start Date"
                  placeholder="MM/DD/YYYY"
                  disabledDate={(d) => !d || d.isBefore(nowV2(), 'day')}
                  onChange={() => {}}
                />
              </form>
            )}
          </Formik>
        </Row>
      </Modal>
    </div>
  )
}

export default RenewalBanner
